module.exports = __webpack_public_path__ + "static/media/(LH)-Prata-05.24b3df94.jpg";